import { createSlice, isAnyOf } from '@reduxjs/toolkit'
import { downloadSkuFileAsync } from 'src/services/shouldCostAIBased.services'

const initialState = {
  editedProjectId: null,
  downloadAttachedFileLoader: false,
}

export const editShouldCostSlice = createSlice({
  name: 'show-edited-project-selected',
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(downloadSkuFileAsync.pending), (state) => {
      state.downloadAttachedFileLoader = true
    })
    builder.addMatcher(isAnyOf(downloadSkuFileAsync.fulfilled), (state, action) => {
      state.downloadAttachedFileLoader = false
    })
    builder.addMatcher(isAnyOf(downloadSkuFileAsync.rejected), (state, action) => {
      state.downloadAttachedFileLoader = false
    })
  },
  reducers: {
    setEditedProjectId: (state, action) => {
      state.editedProjectId = action.payload
    },
    clearEditedProjectId: () => initialState,
  },
})

export const { setEditedProjectId, clearEditedProjectId } = editShouldCostSlice.actions

export default editShouldCostSlice.reducer
